import React, { useContext } from 'react';
import { IUsersContext, UsersContext } from '../../../usersState/usersContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, users } = useContext<IUsersContext>(UsersContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={users.usersCount ? 800 : undefined}
		/>
	);
};

export default Search;
